export const selectCardProviders = (state: IGlobalState): ICardProvider[] =>
  state.cardProvider.providers
export const selectCardLinkPayment = (state: IGlobalState): ICardLinkPaymentDTO =>
  state.cardProvider.cardLinkResponse
export const selectCardVoucherResponse = (state: IGlobalState): ICardVoucherDTO =>
  state.cardProvider.cardVoucherResponse
export const selectCardLinkRequest = (state: IGlobalState): ICardLinkRequest =>
  state.cardProvider.linkRequest
export const selectSeeCardPaymentStatus = (state: IGlobalState): ICardLinkRequest =>
  state.cardProvider.seeCardPaymentStatus
export const selectCardProviderTermsConditions = (state: IGlobalState): string =>
  state.cardProvider.termsConditions
export const selectCardPaymentDevices = (
  state: IGlobalState,
): ICardProviderDeviceDetail[] => state.cardProvider.providerDevices
